module.exports = __webpack_public_path__ + "img/play-icon-blue.03993a96.svg";